import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";
import TryItButton from "../../../TryItButton";
import OutputBox from "../../../OutputBox";

export default function JS_Generators() {
  return (
    <div className="tutorial-container read-only">
      <h1 className="tutorial-title">⚡ JavaScript Generators</h1>

      <div
        className="tutorial-section"
        style={{
          background: "linear-gradient(135deg, #fef3c7, #fde68a)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
          paddingLeft: "35px",
        }}
      >
        <h2 className="section-title">💡 What are Generators?</h2>
        <p>
          Generators are special functions that can pause execution and resume
          later using <code className="highlight_code ">yield</code>. They
          produce multiple values on demand.
        </p>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Simple Generator</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`function* courseGenerator() {
  yield "JavaScript";
  yield "React";
  yield "Node";
}
let gen = courseGenerator();
console.log(gen.next().value); // JavaScript
console.log(gen.next().value); // React
console.log(gen.next().value); // Node`}
          />
          <TryItButton
            code={`function* courseGenerator() {
  yield "JavaScript";
  yield "React";
  yield "Node";
}
let gen = courseGenerator();
console.log(gen.next().value);
console.log(gen.next().value);
console.log(gen.next().value);`}
          />
        </div>
        <OutputBox>
          <pre>
            JavaScript{"\n"}React{"\n"}Node
          </pre>
        </OutputBox>
      </div>

      {/* Example 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Generator with Loop</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`function* numberGenerator(limit) {
  for (let i = 1; i <= limit; i++) {
    yield i;
  }
}
let gen = numberGenerator(3);
console.log(gen.next().value); // 1
console.log(gen.next().value); // 2
console.log(gen.next().value); // 3`}
          />
          <TryItButton
            code={`function* numberGenerator(limit) {
  for (let i = 1; i <= limit; i++) {
    yield i;
  }
}
let gen = numberGenerator(3);
console.log(gen.next().value);
console.log(gen.next().value);
console.log(gen.next().value);`}
          />
        </div>
        <OutputBox>
          <pre>
            1{"\n"}2{"\n"}3
          </pre>
        </OutputBox>
      </div>

      {/* Example 3 */}
      <div className="tutorial-section">
        <h2 className="section-title">3️⃣ Infinite Generator</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`function* idGenerator() {
  let id = 1;
  while(true) {
    yield id++;
  }
}
let gen = idGenerator();
console.log(gen.next().value); // 1
console.log(gen.next().value); // 2
console.log(gen.next().value); // 3`}
          />
          <TryItButton
            code={`function* idGenerator() {
  let id = 1;
  while(true) {
    yield id++;
  }
}
let gen = idGenerator();
console.log(gen.next().value);
console.log(gen.next().value);
console.log(gen.next().value);`}
          />
        </div>
        <OutputBox>
          <pre>
            1{"\n"}2{"\n"}3
          </pre>
        </OutputBox>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#1e40af" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>
            Combine generators with loops to process large or infinite data
            efficiently.
          </li>
          <li>
            Use <code className="highlight_code ">yield</code> to produce values
            on demand.
          </li>
          <li>
            Create custom generator functions for your own objects or classes.
          </li>
          <li>
            Compare generators vs iterators for advanced iteration control.
          </li>
        </ul>
      </div>
    </div>
  );
}
